import { render, staticRenderFns } from "./medicamentos.vue?vue&type=template&id=02def074&"
import script from "./medicamentos.vue?vue&type=script&lang=js&"
export * from "./medicamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports